import IconButton from 'components/IconButton';
import { useSetAtom, useAtomValue } from 'jotai';
import React, { useEffect } from 'react';

import { assetDataAtom, forceRerenderAssetGridAtom } from './state';
import { appliedHostIdsAtom, policyIdFilterAtom } from '../state';

const ResetDashboardButton: React.FC = () => {
  const appliedHostIds = useAtomValue(appliedHostIdsAtom);
  const setAppliedHostIds = useSetAtom(appliedHostIdsAtom);
  const listingData = useAtomValue(assetDataAtom);
  const forceRerenderUI = useSetAtom(forceRerenderAssetGridAtom);
  const setPolicyId = useSetAtom(policyIdFilterAtom);

  const markAppliedRows = (rowIds: number[]) => {
    if (listingData) {
      for (let i = 0; i < listingData.results?.length; i++) {
        const row = listingData.results[i];
        row['isAppliedForDashboard'] = false;
      }
      const effectedRows = listingData?.results?.filter((row) =>
        rowIds.includes(row.id),
      );
      if (effectedRows?.length > 0) {
        effectedRows.forEach((row) => {
          row['isAppliedForDashboard'] = true;
        });
      }
      forceRerenderUI(Math.random().toString());
    }
  };

  useEffect(() => {
    markAppliedRows(appliedHostIds);
  }, [appliedHostIds, listingData]);

  return (
    <IconButton
      id="resetButton"
      iconClass="fa fa-undo fa-lg"
      tooltip="Reset Dashboard Charts"
      disabled={appliedHostIds.length === 0}
      onClick={() => {
        markAppliedRows([]);
        setAppliedHostIds([]);
        // remove the host_id params from URL
        const url = new URL(window.location.href);
        url.searchParams.delete('host_id');
        window.history.replaceState({}, '', url.toString());

        // reset dashboard selected policy filter
        setPolicyId('all');
      }}
    />
  );
};

export default ResetDashboardButton;
